import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  HEADERS,
  ENDPOINTS,
} from 'src/app/core/constants/generic-headers.constants';
import { ServiceType } from 'src/app/core/constants/service-type.constant';

import {
  ILoginToSwitchResponse,
  ISwitchPaymentOption,
  IswitchPaymentOptionResponse,
} from 'src/app/pages/hiring/interfaces/validations.interface';
import {
  LoginToSwitchAdapter,
  SwitchPaymentOptionAdapter,
} from 'src/app/pages/hiring/adapters/validations.adapter';

export abstract class PaymentRequirementServiceBase {
  abstract checkPaymentRequirement(
    typeService: ServiceType,
  ): Observable<ISwitchPaymentOption>;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentRequirementService extends PaymentRequirementServiceBase {
  private readonly apiUrl = environment.baseUrl;
  private readonly _http = inject(HttpClient);

  override checkPaymentRequirement(
    typeService: ServiceType,
  ): Observable<ISwitchPaymentOption> {
    const loginPayload = {
      username: environment.switchPaymentsOptions.username,
      password: environment.switchPaymentsOptions.password,
    };

    return this._http
      .post<ILoginToSwitchResponse>(
        `${this.apiUrl}${ENDPOINTS.hiring.loginToSwitch}`,
        loginPayload,
      )
      .pipe(
        map(LoginToSwitchAdapter),
        switchMap((loginRes) => {
          const tokenValue = loginRes.access_token;
          const headers = new HttpHeaders()
            .set('x-ord-service', HEADERS.xOrdService)
            .set('Authorization', `Bearer ${tokenValue}`);

          const body = { typeService };

          return this._http.post<IswitchPaymentOptionResponse>(
            `${this.apiUrl}${ENDPOINTS.hiring.switchPaymentOption}`,
            body,
            { headers },
          );
        }),
        map(SwitchPaymentOptionAdapter),
      );
  }
}
